<template>
  <div class="reservation-item-mini-component">
    <div class="row res-item-header">
      <div class="col-xs-6">
      <h4>Reservation #{{ reservation.reservationId }}</h4>
      </div>
      <div class="col-xs-6 text-right">
        <label class="label label-default label-header" v-if="reservation.FinanceCode">{{ reservation.FinanceCode.code }} - {{ reservation.FinanceCode.description }}</label>
        <label class="label label-warning label-header" v-if="!reservation.isPersonal && !reservation.FinanceCode">Business Reservation</label>
        <label class="label label-info label-header" v-if="reservation.isPersonal && !reservation.FinanceCode">Personal Reservation</label>
        <label class="label label-primary label-header" v-if="reservation.LotRelocationUuid">One Way Trip</label>
        <label class="label label-info" v-if="reservation.ReservationPromo">
          <span class="fa fa-fw fa-usd"></span> <strong>Promotional Code - {{ reservation.ReservationPromo.code }}</strong>
        </label>
        <label class="label label-primary" v-if="reservation.percentDiscount > 0">
          <span class="fa fa-fw fa-percent"></span> <strong>Discount - {{ reservation.percentDiscount }}%</strong>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 col-sm-2 col-xs-12">
        <img class="img-thumbnail" v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+ ( reservation.Car.CarType.AmazonImage.objectKey ? reservation.Car.CarType.AmazonImage.objectKey : 'spacer.gif' ) + '?v=' + new Date().getTime()"/>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-12">
        <span class="driver-name"><strong>Driver:</strong> {{ reservation.Account.fullName }}</span>
        <p>
          <strong>Start:</strong> {{ reservation.startDate | date_format reservation.Lot.timezone }}<br/>
          <strong>End:</strong> {{ reservation.endDate | date_format reservation.Lot.timezone }}
        </p>
        <p><strong>Total Charges:</strong> ${{ reservation.quotedCost }}</p>
        <p>
          <label class="label label-info label-margin" v-if="reservation.started && !reservation.completed">Started</label>
          <label class="label label-success label-margin" v-if="reservation.completed && !reservation.cancelled">Completed</label>
          <label class="label label-warning label-margin" v-if="reservation.completed && reservation.cancelled">Completed Early</label>
          <label class="label label-danger label-margin" v-if="reservation.cancelled && !reservation.completed">Cancelled</label>
          <label class="label label-danger label-margin" v-if="expired && !reservation.cancelled && !reservation.completed">Expired</label>
          <label class="label label-info label-margin" v-if="reservation.refunded">Refunded</label>
        </p>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-12">
        <h4 class="list-group-item-heading">Car Details</h4>
        <p><strong>{{ reservation.Car.CarType.name }}</strong><br/>
        {{ reservation.Car.name }} (#{{ reservation.Car.convadisId }} - {{ reservation.Car.rego }})</p>
        <p>
        <template v-if="reservation.Lot.premiumAmount > 0">
          <p><strong>{{ reservation.Lot.premiumAmount | currency_round }} Premium</strong><br>
            {{ reservation.Lot.premiumReason }}
          </p>
        </template>
        <template v-for="feature in reservation.Car.CarFeatures">
          <i v-if="feature.icon" v-bind:class="'fa ' + feature.icon + ' fa-lg fa-feature'"></i>
        </template>
      </div>
      <div class="col-md-4 col-sm-4 col-xs-12">
        <h4 class="list-group-item-heading"><span class="fa fa-map-marker"></span> Car Pickup Location</h4>
        <strong>{{ reservation.Lot.address }}</strong><br/>
        <em>{{ reservation.Lot.addressMemo }}</em><br/><br/>
        <a v-bind:href="'https://www.google.com/maps?q='+ reservation.Lot.latitude +','+ reservation.Lot.longitude" target="_blank" class="no-margin btn btn-default btn-xs"><span class="fa fa-fw fa-map"></span> View on Google Maps</a>
      </div>
    </div>
    <template v-if="reservation.LotRelocationUuid">
      <h4><span class="fa fa-map-marker"></span> Car Return Location</h4>
      <p>
        <strong>{{ reservation.DestinationLot.address }}</strong><br/>
        <em>{{ reservation.DestinationLot.addressMemo }}</em><br/><br/>
        <a v-bind:href="'https://www.google.com/maps?q='+ reservation.DestinationLot.latitude +','+ reservation.DestinationLot.longitude" target="_blank" class="btn no-margin btn-default btn-xs"><span class="fa fa-fw fa-map"></span> View on Google Maps</a>
      </p>
    </template>
    <div class="row">
      <div class="col-sm-12">
        <a v-link="{ path: '/reservation/' + reservation.uuid }" class="btn btn-sm btn-info"><span class="fa fa-fw fa-search"></span>View Reservation</a>
        <template v-if="!expired">
          <span v-if="!reservation.completed && !reservation.cancelled">
            <button v-on:click="modifyReservation()" class="btn btn-default btn-sm"><span class="fa fa-fw fa-edit"></span>Modify Reservation</button>
            <button v-if="haveTimeCancelReservation" v-on:click="cancelReservation()" class="btn btn-danger btn-sm"><span class="fa fa-fw fa-ban"></span>{{ reservation.started ? 'Complete' : 'Cancel' }} Reservation</button>
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'ReservationItemMini',
  props: {
    reservation: {
      type: Object
    },
    accountUuid: {
      type: String
    }
  },
  route: {
    data () {

    }
  },
  data () {
    return {
      expired: false
    }
  },
  ready () {
    let now = moment()
    if (now.isAfter(this.reservation.endDate)) this.expired = true
    if (this.reservation.chargeId && this.reservation.chargeId.indexOf('ch_') === 0) {
      this.reservation.chargeId = false
    }
  },
  computed: {
    haveTimeCancelReservation () {
      const currentTime = moment()
      const limitToCancel = moment(this.reservation.startDate).subtract(1, 'hours')
      if (currentTime.isBefore(limitToCancel)) {
        return true
      }
      return false
    }
  },
  methods: {
    cancelReservation () {
      this.$parent.cancelReservationModal(this.reservation)
    },
    modifyReservation () {
      this.$parent.modifyReservationModal(this.reservation)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReservationItemMini.vue?4e05fbce